<template>
    <v-tooltip>
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="lgs-status" :class="statusColor"></div>
        </template>
        <span>{{ $t('enums.unitStateTypes.' + stateId) }}</span>
    </v-tooltip>
</template>

<script>
// iot-api-svc's /sites/{id} no longer returns a precomputed {id, color} pair for the unit state -
// just the raw SiteState.UnitState enum - so the color is now decided here.
const colorByState = {
    NORMAL         : "success",
    STANDSTILL     : "warning",
    LONG_STANDSTILL: "error",
    UNKNOWN        : "grey",
    CREATED        : "info",
};

export default {
    name: "PLiftguardianStatus",

    props: {
        status: {
            required: true,
            type    : Object,
            default : function () {
                return null;
            }
        },
    },

    computed: {
        stateId () {
            return this.status.state.unitState.state;
        },

        statusColor () {
            return colorByState[this.stateId] || "grey";
        }
    }
}
</script>

<style scoped>

.lgs-status {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-top: 3px;
    box-shadow: 0 0 0 1px white;
}

</style>
